<template>
  <v-card flat class="py-5 px-1 px-md-5">
    <v-card-text>
      <v-row no-gutters v-if="user">
        <v-avatar class="mr-3 mt-1">
          <img v-if="avatarSrc" :src="avatarSrc" width="100%" height="auto" />
          <v-icon v-else icon="custom:avatar" size="100%" />
        </v-avatar>
        <v-card-subtitle class="d-flex flex-column text-grey pt-0">
          <span class="font-weight-medium text-h6">
            {{ user.fullName }}
          </span>
          <span>
            {{ user.email }}
          </span>
        </v-card-subtitle>
        <v-spacer />
        <CustomTextButton v-if="editable" @click="emit('edit')">
          Edit my details
        </CustomTextButton>
      </v-row>
      <v-row no-gutters align="center" v-else>
        <v-skeleton-loader type="avatar" class="mr-3" />
        <v-skeleton-loader type="text, text" width="30%" />
        <v-spacer />
      </v-row>
    </v-card-text>

    <v-card-title>Assigned trips</v-card-title>
    <v-card-text>
      Feature under construction. This will be a list of trips currently assigned to this user to complete.
    </v-card-text>
  </v-card>
</template>
<script lang="ts" setup>
import CustomTextButton from "@/components/ui-elements/buttons/custom-buttons/CustomTextButton.vue";
import type User from "@/domains/user/user";
import { computed } from "vue";

const { user, editable = false } = defineProps<{
  /** The user whose details are being displayed. Undefined renders a loading skeleton. */
  user?: User;
  /** Whether the edit button is shown. */
  editable?: boolean;
}>();

const emit = defineEmits<{
  edit: [];
}>();

const avatarSrc = computed(() => user?.avatarURL);
</script>
